import React from 'react';
import { Skeleton } from '@edx/paragon';

export const LoadingView = () => (
  <Skeleton height={100} />
);

export default LoadingView;
